import { createContext, useContext, useCallback, useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const ChatCtx = createContext(null);
export const useChat = () => useContext(ChatCtx) || { unread: { total: 0, mentions: 0, by_conversation: {} }, users: [], refreshUnread: () => {} };

export function ChatProvider({ children }) {
  const { user } = useAuth();
  const [unread, setUnread] = useState({ total: 0, mentions: 0, by_conversation: {} });
  const [users, setUsers] = useState([]);
  const prevMentions = useRef(0);
  const primed = useRef(false);

  const refreshUnread = useCallback(() => {
    api.get("/chat/unread")
      .then((r) => {
        const data = r.data || { total: 0, mentions: 0, by_conversation: {} };
        setUnread(data);
        if (primed.current && data.mentions > prevMentions.current) {
          toast.info("You were mentioned in a conversation");
        }
        prevMentions.current = data.mentions;
        primed.current = true;
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!user) {
      primed.current = false;
      setUnread({ total: 0, mentions: 0, by_conversation: {} });
      return;
    }
    api.get("/chat/users").then((r) => setUsers(r.data || [])).catch(() => {});
    refreshUnread();
    const t = setInterval(refreshUnread, 10000);
    return () => clearInterval(t);
  }, [user, refreshUnread]);

  return <ChatCtx.Provider value={{ unread, users, refreshUnread }}>{children}</ChatCtx.Provider>;
}
